// removed by extract-text-webpack-plugin
module.exports = {"basewrapper":"_3h0iQ","ingress":"_2OELU","textwrapper":"_1BitV _3h0iQ"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Ingressmulti/ingressmulti.scss
 ** module id = 443
 ** module chunks = 0
 **/